import type { APIConfig, AppEnvironment } from '@/apis/infrastructures'
import { COMMITTED_TIME, getAPIBaseURL } from '@/config'

export const APIConfigProvider = (apiToken?: APIToken): APIConfig => {
  return {
    apiToken,
    env: import.meta.env.MODE as AppEnvironment,
    committedTime: COMMITTED_TIME,
    cinnamonUrl: getAPIBaseURL('cinnamon'),
    derekUrl: getAPIBaseURL('dolphin'),
    qrUrl: getAPIBaseURL('qr'),
    bigbrotherUrl: getAPIBaseURL('bigbrother'),
    bigbrotherV2Url: getAPIBaseURL('bigbrotherV2grpc'),
    cinnamonWsUrl: getAPIBaseURL('cinnamonWs'),
    hotelUrl: getAPIBaseURL('hotel'),
  }
}
